<template>
  <div class="side-menu">
    <div class="menu-item" v-for="item of items" :key="item.name" :class="{child: item.isChild, current: item.to == currentPath}" @click="onItemClick(item)">
      <fa :icon="item.icon" style="font-size: 1.3em;" />&nbsp;
      <template v-if="showText">{{ item.name}}</template>
    </div>

    <br />
    <div class="menu-item sign-out" @click="signOut">
      <i class="fas fa-sign-out-alt"></i>
      sign out
    </div>

    <div class="version" v-if="version">
      v{{ version}}
    </div>
    <div class="version update" v-if="needsUpdate">
      v{{ systemData.version}}
    </div>

    <div v-if="user && user.firstName === 'Shaun' && user.lastName === 'Forke'"><router-link to="/test">test</router-link></div>

  </div>
</template>

<script>

import { unregister } from 'register-service-worker'
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  name: 'SideMenu',
  data () {
    return {
      showText: true,
      systemData: null
    }
  },
  computed: {
    version () { return this.$store.getters.version },
    currentPath () { return this.$route.path },
    user () { return this.$store.getters.user },
    pages () { return this.$store.getters.pages },
    items () {
      if (!this.user) {
        return []
      }
      let items = []
      for (let item of this.pages) {
        if (!item.privilege) {
          items.push(item)
        } else {
          let privs = item.privilege.split(', ')
          for (const p of privs) {
            if (this.user.privileges.includes(p)) {
              items.push(item)
              break
            }
          }
        }
      }
      return items
    },
    needsUpdate () {
      return this.systemData && Number(this.systemData.version) > Number(this.version)
    }
  },
  watch: {
    needsUpdate () {
      if (this.needsUpdate) {
        this.$dialog.confirm({
          title: `App Update - v${this.systemData.version}`,
          message: 'There has beed an app update. Please reload the app.',
          confirmText: 'Reload',
          onConfirm () { window.location.reload() }
        })
        unregister()
      }
    }
  },
  created () {
    this.subs.settings = this.$firestore.collection('settings')
      .doc('system')
      .onSnapshot(snapShot => {
        this.systemData = this.$utils.snapshotToObj(snapShot)
      })
  },
  methods: {
    onItemClick (item) {
      this.$router.push(item.to)
      this.$emit('link-click')
    },
    signOut () {
      this.$dialog.confirm({
        message: 'Are you sure you want to sign out?',
        onConfirm: () => {
          this.$emit('link-click')
          firebase.auth().signOut()
            .then(() => this.$router.replace('sign-in'))
        }
      })
    },
    test () {
      this.$router.push('test')
    }
  }
}
</script>

<style>
.side-menu .menu-item {
  padding: 10px;
  color: #ccc;
  font-size: 14px;
  cursor: pointer;
  border-bottom: solid 1px #333;
}

.side-menu .menu-item:hover {
  color: #fff;
  background-color: #333;
}

/* .side-menu .menu-item.child:before {
  content: '- ';
} */
.side-menu .menu-item.child {
  font-size: 12px;
  margin-left: 10px;
  padding-left: 5px;
  background-color: #222;
  border-left: solid 1px #333;
}

.side-menu .menu-item.child:hover {
  background-color: #333;
}

.side-menu .menu-item.current {
  background-color: #555;
  color: #fff;
  font-weight: bold;
}

.sign-out {
  color: #ccc;
  cursor: pointer;
  background-color: #222;
  border-top: solid 1px #333;
}
/* .side-menu a.menu-item svg {
  vertical-align: middle;
} */

.side-menu .version {
  font-size: 12px;
  padding: 5px 0 0 5px;
  color: rgba(255, 255, 255, 0.5)
}

.side-menu .version.update {
  color: rgba(255, 0, 0, 0.5)
}
.side-menu .version.update:before {
  content: '*'
}
</style>
